import { customAxios } from './customAxios'

export function addDocumentiOpzionali(body) {
  const config = {
    headers: {
      AuthToken: JSON.parse(localStorage.getItem('token')),
    },
  }

  const addDocumentiOpzionaliRequest = customAxios.post(
    process.env.REACT_APP_BACKEND_HOST +
      '/' +
      process.env.REACT_APP_PATH_NEW_PREFIX +
      '/addDocumentiOpzionali',
    body,
    config,
  )
  return addDocumentiOpzionaliRequest
}
